<template>
  <Modal :title="$t('global.select-environment-type')" @close="close" :hide-footer="true">
    <template #body>
      <div class="d-flex justify-content-around">
        <Btn class="mr-2" @click="selectDev">
          {{ $t("global.create-development-site") }}
        </Btn>
        <Btn class="mr-2" @click="selectStaging">
          {{ $t("global.create-staging-site") }}
        </Btn>
      </div>
    </template>
  </Modal>
</template>

<script>
import Btn from "@/components/display/Btn";
import DevSiteAddModal from "@/components/smart/modals/DevSiteAdd";
import FreeTrialPayWallModal from "@/components/smart/modals/FreeTrialPayWall";
import Modal from "@/components/display/Modal";
import store from "@/store";

export default {
  name: "DevStagingSelectionModal",
  components: {
    Modal,
    Btn,
  },
  props: {
    data: {
      type: Object,
      required: true,
      validator: (value) => {
        const hasSite = !!value.site && typeof value.site === "object";
        const hasPlan = !!value.plan && typeof value.plan === "object";

        return hasSite && hasPlan;
      },
    },
  },
  setup(props, { emit }) {
    const { site, plan } = props.data;

    const close = () => {
      emit("close");
    };

    const selectDev = () => {
      emit("close");
      if (!plan.package.isFreeTrial) {
        store.dispatch("modals/open", {
          template: DevSiteAddModal,
          data: { site, plan, environmentType: "development" },
        });
      } else {
        store.dispatch("modals/open", {
          template: FreeTrialPayWallModal,
          data: {
            package: plan.package,
            app: site.app,
            plan,
          },
        });
      }
    };

    const selectStaging = () => {
      emit("close");
      store.dispatch("modals/open", {
        template: DevSiteAddModal,
        data: { plan, site, environmentType: "staging" },
      });
    };

    return {
      close,
      selectDev,
      selectStaging,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables";
</style>
